$(function(){
    let Slider1 = new Swiper(".c4_swiper", {
        loop: true,
        speed: 1000,
        spaceBetween: 190,
        autoplay: {
            delay: 3000,
        },
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
            coverflowEffect: {
            rotate: 0,
            stretch: 80,
            depth: 200,
            modifier: 1,
            slideShadows: false,
        },
        pagination: {
            el: ".c4-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                let list = ["開發新品", "商品管理", "店舖管理","數位員工"];
                return (
                    `<div class="${className}"><div class="c4_cri"></div>${list[index]}</div>`
                );
            },
        },
        navigation: {
            nextEl: ".c4-button-next",
            prevEl: ".c4-button-prev",
        },
    });

    let Slider2 = new Swiper(".c5_slideMB", {
        freeMode: true,
        slidesPerView: "auto",
        scrollbar: {
            el: ".c5_imgsMB .swiper-scrollbar",
            hide: false,
            draggable: true,
            snapOnRelease: false,
        },
    });
});